import { render, staticRenderFns } from "./HotelCreate.vue?vue&type=template&id=88f593d4"
import script from "./HotelCreate.vue?vue&type=script&lang=js"
export * from "./HotelCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports